/* ==========================================================================
   LAKSHIV ENTERPRISE — B2B + B2C Experience Controller
   ========================================================================== */

(function () {
  'use strict';

  window.logB2B = function (msg) {
    console.log('[B2B Debug] ' + msg);
  };

  // Dynamic loader for nice-team Bundler app script to ensure compatibility in draft theme previews
  var isBndlrScriptPresent = false;
  var scriptTags = document.getElementsByTagName('script');
  for (var i = 0; i < scriptTags.length; i++) {
    var src = scriptTags[i].getAttribute('src') || '';
    if (src.indexOf('nice-team.net') !== -1 || src.indexOf('cdn-bundler') !== -1) {
      isBndlrScriptPresent = true;
      break;
    }
  }

  if (!isBndlrScriptPresent && (typeof window.BndlrScriptAppended === 'undefined' || window.BndlrScriptAppended === false)) {
    window.BndlrScriptAppended = true;
    var shopDomain = (window.Shopify && window.Shopify.shop) || '6jnzbq-9i.myshopify.com';
    var loadBndlrScript = function (src, cb) {
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = src;
      s.onload = cb;
      s.onerror = cb;
      document.getElementsByTagName('head')[0].appendChild(s);
    };
    var timeStamp = Math.floor(Date.now() / 1000);
    var statusUrl = 'https://bundler.nice-team.net/app/shop/status/' + shopDomain + '.js?' + timeStamp;
    loadBndlrScript(statusUrl, function () {
      var settingsUpdated = window.bundler_settings_updated || 'default-by-script';
      var scriptUrl = 'https://cdn-bundler.nice-team.net/app/js/bundler-script.js?shop=' + shopDomain + '&' + settingsUpdated;
      loadBndlrScript(scriptUrl, function () {});
    });
  }

  var L = (window.Lakshiv = window.Lakshiv || {});
  var settings = L.settings || {};

  var MODE_STORAGE_KEY = 'lakshiv_shopping_mode';
  var RETAIL_MODE = 'retail';
  var BUSINESS_MODE = 'business';

  // Read active mode from localStorage (defaulting to the defaultShoppingMode setting)
  var currentMode = localStorage.getItem(MODE_STORAGE_KEY) || settings.defaultShoppingMode || RETAIL_MODE;

  // Immediately set document attribute to prevent FOUC (Flash of Unstyled Content)
  document.documentElement.setAttribute('data-shopping-mode', currentMode);

  // Expose active mode globally
  L.shoppingMode = currentMode;

  function initSwitcher() {
    logB2B('initSwitcher started. Active mode: ' + currentMode);

    document.addEventListener('bundler:bundle_widget_created', function () {
      console.log('[B2B Debug] Global bundler:bundle_widget_created fired - adding hide class.');
      document.documentElement.classList.add('b2b-hide-default-widget');
    });

    // Update active visual state inside the switcher modal options
    var modal = document.getElementById('ShoppingModeModal');
    if (modal) {
      var cards = modal.querySelectorAll('.shopping-mode__card');
      cards.forEach(function (card) {
        if (card.getAttribute('data-mode-option') === currentMode) {
          card.classList.add('is-active');
        } else {
          card.classList.remove('is-active');
        }
      });
    }

    // Update switcher labels in header and mobile top bar
    var switcherLabels = document.querySelectorAll('[data-shopping-mode-text]');
    var activeLabel = currentMode === BUSINESS_MODE 
      ? (settings.switcher_label_business || 'For Business')
      : (settings.switcher_label_retail || 'For Me');
    
    switcherLabels.forEach(function (el) {
      el.textContent = activeLabel;
    });

    // Delegate click events for opening/closing/changing modes
    document.addEventListener('click', function (event) {
      // 1. Open Switcher Modal
      var openBtn = event.target.closest('[data-open-shopping-mode-modal]');
      if (openBtn) {
        event.preventDefault();
        if (L.layers && modal) {
          L.layers.open(modal);
        }
        return;
      }

      // 2. Select shopping mode options inside the modal
      var card = event.target.closest('.shopping-mode__card');
      if (card && modal && L.layers && L.layers.isOpen(modal)) {
        var selectedMode = card.getAttribute('data-mode-option');
        if (selectedMode) {
          cards.forEach(function (c) { c.classList.remove('is-active'); });
          card.classList.add('is-active');
          switchExperience(selectedMode);
        }
        return;
      }

      // 3. Direct mode selection button click (if any button is targeted directly)
      var selectBtn = event.target.closest('[data-select-mode]');
      if (selectBtn) {
        event.preventDefault();
        var mode = selectBtn.getAttribute('data-select-mode');
        if (mode) {
          switchExperience(mode);
        }
        return;
      }

      // 4. Toggle premium dropdown menus
      var trigger = event.target.closest('[data-dropdown-trigger]');
      if (trigger) {
        event.preventDefault();
        var dropdown = trigger.closest('[data-dropdown]');
        if (dropdown) {
          dropdown.classList.toggle('is-open');
          // If opened, reset search input and focus it
          if (dropdown.classList.contains('is-open')) {
            var searchInput = dropdown.querySelector('[data-dropdown-search]');
            if (searchInput) {
              searchInput.value = '';
              var items = dropdown.querySelectorAll('.announcement__dropdown-item');
              items.forEach(function (item) {
                item.style.display = '';
              });
              setTimeout(function () {
                searchInput.focus();
              }, 100);
            }
          }
        }
        // Close all other dropdowns
        document.querySelectorAll('[data-dropdown]').forEach(function (d) {
          if (d !== dropdown) {
            d.classList.remove('is-open');
          }
        });
        return;
      }

      // 5. Select country/region from the premium dropdown list
      var dropdownItem = event.target.closest('.announcement__dropdown-item');
      if (dropdownItem) {
        event.preventDefault();
        var countryForm = dropdownItem.closest('form');
        var countryVal = dropdownItem.getAttribute('value') || dropdownItem.value;
        if (countryForm && countryVal) {
          localStorage.setItem('lakshiv_selected_country', countryVal.toUpperCase());
          var countryInput = countryForm.querySelector('input[name="country_code"]');
          if (!countryInput) {
            countryInput = document.createElement('input');
            countryInput.type = 'hidden';
            countryInput.name = 'country_code';
            countryForm.appendChild(countryInput);
          }
          countryInput.value = countryVal;
          countryForm.submit();
        }
        return;
      }

      // Close dropdowns when clicking outside
      if (!event.target.closest('[data-dropdown]')) {
        document.querySelectorAll('[data-dropdown]').forEach(function (d) {
          d.classList.remove('is-open');
        });
      }
    });

    // Listen for change events on country/locale select inputs to submit forms automatically
    document.addEventListener('change', function (event) {
      if (event.target.name === 'country_code' || event.target.name === 'locale_code') {
        var form = event.target.closest('form');
        if (form) {
          if (event.target.name === 'country_code') {
            localStorage.setItem('lakshiv_selected_country', event.target.value.toUpperCase());
          }
          form.submit();
        }
      }
    });

    // Run specific setup when Business mode is active
    if (currentMode === BUSINESS_MODE) {
      initBusinessProductPage();
    }
  }

  /**
   * Triggers the personalized loading animation screen for 2s before reloading the website in the selected mode.
   */
  function switchExperience(mode) {
    if (L.layers) {
      L.layers.closeAll();
    }

    var loader = document.getElementById('ShoppingLoader');
    if (loader) {
      loader.removeAttribute('hidden');
    }

    localStorage.setItem(MODE_STORAGE_KEY, mode);
    var duration = (parseFloat(settings.loaderDuration) || 2) * 1000;

    setTimeout(function () {
      window.location.reload();
    }, duration);
  }

  /**
   * Sets up MOQ and binds volume discount rendering on B2B product page.
   */
  function initBusinessProductPage() {
    logB2B('initBusinessProductPage called.');
    var qtyInput = document.getElementById('BusinessProductQuantity');
    if (qtyInput) {
      var productInfo = document.querySelector('[data-b2b-moq]');
      if (productInfo) {
        var moq = parseInt(productInfo.getAttribute('data-b2b-moq'), 10) || 1;
        qtyInput.setAttribute('min', moq);
        
        // If current quantity is less than MOQ, initialize to MOQ
        var currentVal = parseInt(qtyInput.value, 10) || 1;
        if (currentVal < moq) {
          qtyInput.value = moq;
        }

        // Sync minus/plus button states using the theme's core sync function
        var wrap = qtyInput.closest('[data-quantity]');
        if (wrap && typeof L.syncQuantityButtons === 'function') {
          L.syncQuantityButtons(wrap);
        }
      }
    }

    // Render volume discount breaks fetched dynamically from nice-team's Bundler App client-side API
    initBundlerIntegration();
  }

  /**
   * Checks for active Bundler App instance and renders wholesale quantity discount grid.
   */
  function initBundlerIntegration() {
    var target = document.getElementById('b2b-bundle-pricing-target');
    if (!target) {
      logB2B('initBundlerIntegration: b2b-bundle-pricing-target element not found.');
      return;
    }
    logB2B('initBundlerIntegration: b2b-bundle-pricing-target found. Starting polling...');

    function mountBundlerWidget() {
      var widget = document.querySelector('.bundler-volume-target-element, .bundler-target-element, .bndlr-compat-wrapper');
      if (!widget || target.contains(widget)) return !!widget;
      target.innerHTML = '';
      target.appendChild(widget);
      widget.style.removeProperty('display');
      logB2B('Bundler volume widget mounted in the business purchase panel.');
      return true;
    }

    var attempts = 0;
    var maxAttempts = 50; // Check for up to 5 seconds

    function checkBundler() {
      if (mountBundlerWidget()) return;
      var exists = typeof window.bndlr !== 'undefined';
      var hasGet = exists && typeof window.bndlr.getBundles === 'function';
      var bundlesLength = hasGet && window.bndlr.getBundles() ? window.bndlr.getBundles().length : 0;
      
      logB2B('checkBundler attempt ' + attempts + ': window.bndlr exists=' + exists + ', getBundles=' + hasGet + ', bundlesCount=' + bundlesLength);
      
      if (exists && hasGet) {
        var bundles = window.bndlr.getBundles();
        if (bundles && bundles.length > 0) {
          logB2B('Success! Bundles active. Displaying default app widget natively.');
          return; // Success!
        }
      }
      
      if (attempts < maxAttempts) {
        attempts++;
        setTimeout(checkBundler, 100);
      } else {
        logB2B('Timeout: Bundler failed to return bundles within 5 seconds.');
        if (exists && hasGet && bundlesLength === 0) {
          logB2B('IMPORTANT HELP: The Bundler app script is active, but it returned 0 bundles for this product. This means you need to add this product (or its collection) to the "Volume discount" bundle in your Shopify Admin (Apps -> Bundler).');
        }
        target.innerHTML = '';
      }
    }

    // Listen for bundler events
    document.addEventListener('bundler:loaded', checkBundler);
    document.addEventListener('bundler:bundle_widget_created', checkBundler);

    var observer = new MutationObserver(function () {
      if (mountBundlerWidget()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    checkBundler();
  }

  /**
   * Renders the bulk discount cards grid dynamically.
   */
  function renderBundlerOffers(bundles) {
    logB2B('renderBundlerOffers processing ' + bundles.length + ' bundles.');
    var target = document.getElementById('b2b-bundle-pricing-target');
    if (!target) return;

    var extractQuantity = function (obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          var k = key.toLowerCase();
          if (k.indexOf('qty') !== -1 || k.indexOf('quantity') !== -1 || k.indexOf('count') !== -1 || k.indexOf('min') !== -1 || k === 'q') {
            var val = parseInt(obj[key], 10);
            if (!isNaN(val)) return val;
          }
        }
      }
      return NaN;
    };

    var extractDiscount = function (obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          var k = key.toLowerCase();
          if (k.indexOf('percent') !== -1 || k.indexOf('pct') !== -1 || k.indexOf('discount') !== -1 || k.indexOf('value') !== -1 || k.indexOf('rate') !== -1) {
            var val = parseFloat(obj[key]);
            if (!isNaN(val)) return val;
          }
        }
      }
      return 0;
    };

    if (!bundles || !Array.isArray(bundles) || bundles.length === 0) {
      logB2B('renderBundlerOffers: bundles list is empty.');
      target.innerHTML = ''; // Hide widget if no bundles exist
      return;
    }

    // Filter volume/quantity discounts for the active product
    var activeProductForm = document.getElementById('BusinessProductForm');
    var activeVariantInput = activeProductForm ? (activeProductForm.querySelector('[name="id"]') || activeProductForm.querySelector('[name="variant_id"]')) : null;
    var activeVariantId = activeVariantInput ? activeVariantInput.value : null;

    // Check if the bundle has quantity discount levels
    var discountOffers = [];

    bundles.forEach(function (bundle) {
      // Nice-team's volume discounts can be stored in tiers under different property structures
      var levels = bundle.level_discounts || bundle.levels || bundle.discounts || bundle.discount_levels || bundle.discount_tiers || bundle.rules || bundle.volume_discounts || [];
      if (levels.length > 0) {
        logB2B('Found discount levels. Sample level keys: ' + JSON.stringify(Object.keys(levels[0])));
        logB2B('Sample level values: ' + JSON.stringify(levels[0]));
        levels.forEach(function (level) {
          discountOffers.push({
            bundleId: bundle.id,
            quantity: extractQuantity(level),
            discountPercent: extractDiscount(level),
            title: bundle.title || bundle.name
          });
        });
      }
    });

    // If no volume levels found, try parsing standard bundle configuration
    if (discountOffers.length === 0) {
      bundles.forEach(function (bundle) {
        if (bundle.min_quantity && bundle.discount_percent) {
          discountOffers.push({
            bundleId: bundle.id,
            quantity: parseInt(bundle.min_quantity, 10),
            discountPercent: parseFloat(bundle.discount_percent),
            title: bundle.title || bundle.name
          });
        }
      });
    }

    if (discountOffers.length === 0) {
      target.innerHTML = '';
      return;
    }

    // Sort offers by quantity ascending
    discountOffers.sort(function (a, b) { return a.quantity - b.quantity; });

    // Fetch current variant price robustly from B2B wholesale price or fallback to retail price
    var priceElement = document.querySelector('[data-b2b-price-display]') || document.querySelector('.product-price-block .price');
    var priceText = priceElement ? priceElement.textContent.trim() : '';
    var match = priceText.match(/[\d.,]+/);
    var basePrice = 699;
    if (match) {
      var cleanPrice = match[0].replace(/,/g, '');
      basePrice = parseFloat(cleanPrice) || 699;
    }
    console.log('[B2B Debug] Parsed base unit price for bundles:', basePrice);

    var currencySymbol = (settings.moneyFormat || 'Rs.').replace('{{amount}}', '').trim();

    var html = '<div class="b2b-bundle-pricing">';
    html += '  <h3 class="b2b-bundle-pricing__heading">' + (settings.bundle_heading || 'BUY IN BULK & GET A DISCOUNT') + '</h3>';
    html += '  <div class="b2b-bundle-pricing__grid">';

    discountOffers.forEach(function (offer) {
      var originalTotal = basePrice * offer.quantity;
      var savingsMultiplier = (100 - offer.discountPercent) / 100;
      var discountedTotal = originalTotal * savingsMultiplier;

      var formattedOriginal = currencySymbol + ' ' + originalTotal.toLocaleString('en-IN', { maximumFractionDigits: 0 });
      var formattedDiscounted = currencySymbol + ' ' + discountedTotal.toLocaleString('en-IN', { maximumFractionDigits: 0 });

      html += '    <div class="b2b-bundle-card">';
      html += '      <span class="b2b-bundle-card__badge">Buy ' + offer.quantity + '+</span>';
      html += '      <h4 class="b2b-bundle-card__title">Buy ' + offer.quantity + '</h4>';
      html += '      <p class="b2b-bundle-card__discount">Save ' + offer.discountPercent + '%</p>';
      html += '      <div class="b2b-bundle-card__pricing">';
      html += '        <span class="b2b-bundle-card__original-price">' + formattedOriginal + '</span>';
      html += '        <span class="b2b-bundle-card__discounted-price">' + formattedDiscounted + '</span>';
      html += '      </div>';
      html += '      <button class="btn b2b-bundle-card__btn" type="button" data-buy-bundle-quantity="' + offer.quantity + '" data-bundle-id="' + offer.bundleId + '">Buy Now</button>';
      html += '    </div>';
    });

    html += '  </div>';
    html += '</div>';

    target.innerHTML = html;

    // Bind custom buy button clicks
    bindBundleClicks();
  }

  /**
   * Binds click events to dynamic Buy Now buttons inside the volume pricing grid.
   */
  function bindBundleClicks() {
    var target = document.getElementById('b2b-bundle-pricing-target');
    if (!target) return;

    var buyButtons = target.querySelectorAll('[data-buy-bundle-quantity]');
    buyButtons.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var quantity = parseInt(btn.getAttribute('data-buy-bundle-quantity'), 10);
        var bundleId = btn.getAttribute('data-bundle-id');

        // Locate variant ID
        var activeProductForm = document.getElementById('BusinessProductForm');
        var activeVariantInput = activeProductForm ? (activeProductForm.querySelector('[name="id"]') || activeProductForm.querySelector('[name="variant_id"]')) : null;
        var variantId = activeVariantInput ? activeVariantInput.value : null;

        if (!variantId) {
          L.toast.show('Please select a product variant first.', 'error');
          return;
        }

        btn.disabled = true;
        btn.textContent = 'Adding...';

        // Add bundle items to cart using global cart helper
        if (L.cart && typeof L.cart.add === 'function') {
          L.cart.add({
            id: variantId,
            quantity: quantity,
            properties: {
              '_bundle_id': bundleId,
              'Wholesale Order': 'Bulk Discount Applied'
            }
          }).then(function () {
            btn.disabled = false;
            btn.textContent = 'Buy Now';
          }).catch(function () {
            btn.disabled = false;
            btn.textContent = 'Buy Now';
          });
        } else {
          // Standard form fallback
          var qtyInput = document.getElementById('BusinessProductQuantity');
          if (qtyInput) {
            qtyInput.value = quantity;
            if (activeProductForm) {
              activeProductForm.submit();
            }
          }
        }
      });
    });
  }



  // Run B2B switcher initialization (only if B2B mode is enabled in theme settings)
  if (settings.enableB2bMode) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSwitcher);
    } else {
      initSwitcher();
    }
  }

})();
